// index GroupInvitation
export const DATA_COMPONENT_GROUP_INVITATION_INDEX =
  'group-invitation-page-index';

// Group Not Found
export const DATA_COMPONENT_GROUP_INVITATION_NOT_FOUND =
  'group-invitation-page-not-found';
export const DATA_COMPONENT_GROUP_INVITATION_NOT_FOUND_IMAGE =
  'group-invitation-page-not-found-image';

export const DATA_COMPONENT_GROUP_INVITATION_FOUND_ACTION_BTN =
  'group-invitation-page-found-action-btn';
  
// GroupAvatar
export const DATA_COMPONENT_GROUP_INVITATION_GROUP_AVATAR_IMAGE =
  'group-invitation-page-group-avatar-image';
export const DATA_COMPONENT_GROUP_INVITATION_GROUP_AVATAR_NOIMAGE =
  'group-invitation-page-group-avatar-no-image';

// MemberAvatar
export const DATA_COMPONENT_GROUP_INVITATION_MEMBER_AVATAR_IMAGE =
  'group-invitation-page-member-avatar-image';

// GuestInvitation
export const DATA_COMPONENT_GROUP_INVITATION_GUEST =
  'group-invitation-page-guest';
// GuestInvitation Not Found
export const DATA_COMPONENT_GROUP_INVITATION_GUEST_NOT_FOUND =
  'group-invitation-page-guest-not-found';
